import xClose from "#/src/assets/svg/x-close.svg";

interface Props {
  src: string,
  open: boolean,
  onClose: () => void
}

export function VideoModal({src, open, onClose}: Props) {
  if (!open) {
    return <></>
  }
  return <section className="modal__bg" onClick={onClose}>
    <div className="modal__align">
      <div className="modal__content">
        <div className="modal__video-align">
          <img alt={"Zamknij"} src={xClose} className="modal__close" onClick={onClose}/>
          <iframe
            className="modal__video-style"
            loading="lazy"
            width="800"
            height="500"
            src={src}
            title="Odtwarzacz video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
}